module.exports = __webpack_public_path__ + "img/deusto.4c75dcdb.png";